import React from "react";
import Component from "components";
import {useParams} from "react-router-dom";
import useFetch from "hooks/fetch";
import {Team} from "interfaces";
import Detail from "./detail";
import "assets/styles/team.less"
import data from "./data";

const Project : React.FC = () => {

    const [isLoading, datasource] = useFetch("team", "asc");
    const params                  = useParams<{name : string}>();

    const detail = datasource.find(team => team.nickname === params.name) as Team

    return (
        <Component.Publiclayout>
            <Component.Metadecorator
                title={detail?.name || data.meta.title}
                description={detail?.aboutMe || data.meta.description}
                imageUrl={detail?.image?.url || data.meta.imageUrl}
                imageAlt={detail?.image?.url || data.meta.imageAlt}
            />
            <div className={"team-wrapper"}>
                <Detail
                    detail={detail}
                    team={datasource}
                    selected={params.name}
                    isLoading={isLoading}
                />
            </div>
        </Component.Publiclayout>
    )
}

export default Project